import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "getting-started-with-uxp-for-photoshop"
    }}>{`Getting Started with UXP for Photoshop`}</h1>
    <h2 {...{
      "id": "hello-world"
    }}>{`Hello World`}</h2>
    <p>{`Building your first UXP plugin requires two pieces of software, both of which can be installed via `}<a parentName="p" {...{
        "href": "https://www.adobe.com/creativecloud/desktop-app.html"
      }}>{`Adobe Creative Cloud Desktop`}</a>{` - the latest version of Photoshop, and the `}<a parentName="p" {...{
        "href": "./devtool/installation/"
      }}>{`UXP Developer Tool`}</a>{`.`}</p>
    <p>{`To get started, we suggest following these tutorials to get your hands dirty and get started with building UXP plugins for Photoshop:`}</p>
    <ol>
      <li parentName="ol"><a parentName="li" {...{
          "href": "./getting-started/creating-your-first-plugin/index.md"
        }}>{`Creating your first plugin`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "./getting-started/editing-the-document/index.md"
        }}>{`Editing the document`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "./getting-started/writing-a-file/index.md"
        }}>{`Writing a file with UXP`}</a></li>
    </ol>
    <h2 {...{
      "id": "important-resources"
    }}>{`Important resources`}</h2>
    <h3 {...{
      "id": "the-basics"
    }}>{`The Basics`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./uxp_guide/uxp-misc/manifest-v4/"
        }}>{`The UXP manifest`}</a>{`: Essential to tailoring your UXP plugin.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./devtool/udt-walkthrough/"
        }}>{`UXP Developer Tool Walkthrough`}</a>{`: Learn how to create a plugin from a sample, load and debug it on Photoshop.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../ps_reference/"
        }}>{`The intro to the Photoshop API`}</a>{`: Explore what is offered in the form of the DOM API, the successor to ExtendScript.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../uxp/reference-spectrum/User%20Interface/"
        }}>{`Spectrum UI reference`}</a>{`: UXP provides a smaller set of elements that you should be aware of, before creating UI.`}</li>
    </ul>
    <h3 {...{
      "id": "must-reads"
    }}>{`Must Reads`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../uxp/"
        }}>{`UXP API reference`}</a>{`: The UXP platform offers many, but not all capabilities of a web browser. Learn about what could be familiar, and what is different.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../ps_reference/media/executeasmodal/"
        }}>{`Modal Execution in Photoshop`}</a>{`: A new paradigm for building performant and resilient plugins. If you are building plugins that modifies the users' document, this is an essential read.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "./uxp_guide/uxp-misc/manifest-v4/photoshop-manifest/"
        }}>{`Photoshop manifest`}</a>{`: An addendum to `}<inlineCode parentName="li">{`manifest.json`}</inlineCode>{`. For Adobe Photoshop 2022, you will need to be aware of potential breaking changes related to Modal Execution.`}</li>
    </ul>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`Got a question? The Adobe `}<a parentName="p" {...{
        "href": "https://forums.creativeclouddeveloper.com/"
      }}>{`Creative Cloud Developer Forums`}</a>{` is a great resource for answers!`}</p>
    <h2 {...{
      "id": "explore"
    }}>{`Explore`}</h2>
    <h3 {...{
      "id": "plugin-samples"
    }}>{`Plugin Samples`}</h3>
    <p>{`We've collected a few samples that cover a lot of ground. They may contain code that you need to solve that one frustrating bug! Download and view `}<a parentName="p" {...{
        "href": "./code_samples/"
      }}>{`Code Samples`}</a>{`.`}</p>
    <h3 {...{
      "id": "design-guides"
    }}>{`Design guides`}</h3>
    <p>{`If your plugin contains a visual element, you may want to view our `}<a parentName="p" {...{
        "href": "../design/"
      }}>{`Design Guides`}</a>{` to ensure your users have the best experience.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      